import { CheckboxGroupField, Select } from '@payaca/ambrosia';
import { FC } from 'react';
import { FieldProps } from './fieldInputTypes';

export const MultiSelectFieldInput: FC<FieldProps<'multi-select'>> = (
  props
) => {
  const { definition, value, onChange } = props;

  const chosen = value ?? [];
  const atLimit = chosen.length >= definition.limit;

  const options = definition.options.map((option) => ({
    value: option,
    label: option || '-',
    // At the limit, the already-chosen options stay operable so a choice can
    // still be swapped; only the unchosen ones lock.
    disabled: atLimit && !chosen.includes(option),
  }));

  if (definition.displayMode === 'checkbox') {
    return (
      <CheckboxGroupField
        value={chosen}
        options={options}
        hiddenInput
        emphasised
        onChange={onChange}
      />
    );
  }

  // Without a label the trigger announces as its placeholder, which says
  // nothing about which field it belongs to.
  return (
    <Select
      aria-label={definition.label}
      value={chosen}
      options={options}
      multiple
      onChange={onChange}
    />
  );
};
